import styled from "styled-components";

export default styled.div`
  background-color: #fff;
  z-index: 100;
  padding: 10px 20px;
  border-radius: 4px;
  height: min-content;

  .heading {
    padding: 10px;
    border-bottom: 1px solid lightgray;
    color: ${(props) =>
      props?.variant === "info"
        ? "lightblue"
        : props?.variant === "warning"
        ? "orange"
        : "inherit"};
  }
  .body {
    padding: 10px 0;
    overflow: visible;
  }
`;
